<template>
  <q-page padding>
    <q-form
      class="row justify-center"
      @submit.prevent="handleForgotPassword"
    >
      <h5 class="col-12 text-center">Redefinição de senha</h5>
      <p class="col-12 text-subtitle1 text-center">Para redefinir a sua senha, informe o seu email de cadastro no formulário e clique em Enviar.</p>
      <div class="col-md-4 col-sm-6 col-xs-10  q-gutter-y-md">
        <q-input
          v-model="email"
          label="Email"
          type="email"
          lazy-rules
          :rules="[ val => val && val.length > 0 || 'Favor informe um email valido!']"
        >
          <template v-slot:prepend>
            <q-icon name="mail" />
          </template>
        </q-input>
        <div
          class="g-recaptcha"
          data-sitekey="6LdkwCMeAAAAAKuGHbRLGqNDCnYCW-1HDvsWRrjB"
        ></div>
        <div class="full-width q-mt-md">
          <q-btn
            label="Enviar"
            class="full-width"
            color="primary"
            type="submit"
            icon="send"
          />
        </div>
        <p><b>ATENÇÃO</b>: O email pode ir parar na sua Caixa de Spam / Lixo Eletrônico!</p>
        <div class="full-width">
          <q-btn
            label="Voltar"
            class="full-width"
            flat
            :to="{name: 'login'}"
            icon="arrow_back"
          />
        </div>
        <div class="full-width">
          <p>Não está cadastrado? <a href="/register">Cadastre-se já</a></p>
        </div>
      </div>

    </q-form>

  </q-page>
</template>
<script>
import { defineComponent, ref } from 'vue'
import useAuthUser from '../composables/UseAuthUser'
import useNotify from '../composables/UseNotify'

export default defineComponent({
  name: 'PageForgotPassword',

  setup () {
    const { notifyError, notifySuccess } = useNotify()
    const { sendPasswordResetEmail } = useAuthUser()

    const email = ref('')

    const handleForgotPassword = async () => {
      try {
        await sendPasswordResetEmail(email.value)
        notifySuccess(`Email de redefinição de senha enviado para: ${email.value}`)
      } catch (error) {
        notifyError(error.message)
      }
    }

    return { email, handleForgotPassword }
  }
})
</script>
